import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const DELETE_ACCOUNT_MUTATION = gql`
  mutation deleteAccount($id: String) {
    deleteAccount(where: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteAccountMutation extends Mutation<RootMutation> {
  document = DELETE_ACCOUNT_MUTATION;
}
